import { API, environment } from '@core/envs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IRecall, IResponseModel } from '@core/interface';
import { map, Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecallOwnerService {
  readonly #http = inject(HttpClient);
  #hasRecall = false;
  #recalls: IRecall[] = [];

  getRecall(vin: string, country: string): Observable<IResponseModel<IRecall[]>> {
    const url = `${environment.getRoute(API.owners)}/recalls/application-code/owner?country=${country}&status=O`;
    const headers = new HttpHeaders({ vin });

    return this.#http.get<IResponseModel<IRecall[]>>(url, { headers }).pipe(
      shareReplay(1),
      map((data) => {
        this.#hasRecall = !!data.response.length;
        this.#recalls = data.response;
        return data;
      })
    );
  }

  get hasRecall(): boolean {
    if ('@Ford-recall' in localStorage) {
      this.#hasRecall = JSON.parse(localStorage.getItem('@Ford-recall') as string).hasRecall;
    }
    return this.#hasRecall;
  }

  get recalls(): IRecall[] {
    if ('@Ford-recall' in localStorage) {
      this.#recalls = JSON.parse(localStorage.getItem('@Ford-recall') as string).recall;
    }
    return this.#recalls;
  }
}
